import { FiAlertTriangle } from 'react-icons/fi';

import Card from 'components/ui/card';

/** Aviso da emissão do selo digital (SEL-08). */
export default function AvisoBrasilOpenBadge() {
  return (
    // D3: 18px não tem degrau no Tailwind.
    <Card padded={false} className="flex items-start gap-3.5 px-6 py-[18px]">
      <FiAlertTriangle aria-hidden="true" size={22} className="mt-px shrink-0 text-brand-blue" />
      <p className="m-0 text-sm leading-normal text-content">
        O Selo Digital é emitido pela empresa <b>Brasil Open Badge</b>. Em breve você receberá um e-mail com o título{' '}
        <b>"Ativar o seu Badge"</b> do remetente <b>noreply@brasilopenbadge.com.br</b>.
      </p>
    </Card>
  );
}
